export const environment = {
  production: true,
  server: 'Todo_Production',
  version: '1.0.0-live',
  hostAPI: 'https://todo-app-be-ixcg.onrender.com', // Change to production API endpoint later
};
